import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";
import About from "@/components/About";
import Approach from "@/components/Approach";
import Services from "@/components/Services";
import Expertise from "@/components/Expertise";
import Partners from "@/components/Partners";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function HomePage() {
  return (
    <div className="bg-[#08080A] text-[#ECECEE]" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <About />
        <Approach />
        <Services />
        <Expertise />
        <Partners />
        <Team />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
